// BienvenidaPage.tsx
/* eslint-disable*/

import "../../styles/ABordoPage.css"; // Asegúrate de que la ruta sea correcta
import bienvenido from "../../assets/titulos/bienvenido.png";
import welcome from "../../assets/titles/welcome.png";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import LocalizedTitleImage from "../../components/UseLanguage";
import menuIcon from "../../assets/menu.png";

function ABordoPage() {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  useEffect(() => {
    // 🔓 Habilita scroll solo en esta página
    document.body.style.overflow = "auto";

    return () => {
      // 🔒 Lo bloquea de nuevo al salir (si así lo usas en otras páginas)
      document.body.style.overflow = "hidden";
    };
  }, []);

  console.log(t("abordo.quote"));

  return (
    <div
      className="bienvenida-section fade-tab"
      style={{ backgroundImage: `` }}
    >
        <div className="menu-icon-div">
          <img src={menuIcon} />
        </div>
      <div className="bienvenida-overlay">
        <div className="title-wrapperab">
          <LocalizedTitleImage
            imageEn={welcome}
            imageEs={bienvenido}
            className="title-logoab"
          />
        </div>

        <section className="welcome-quote">
          <p>{t("abordo.quote")}</p>
        </section>

        <section className="intro-text">
          <p>{t("abordo.intro")}</p>
        </section>
      </div>
    </div>
  );
}

export default ABordoPage;
